import ModelsStandLocations from './models-stand-locations';

export default ModelsStandLocations;
